module.exports = __webpack_public_path__ + "img/banner.1a126b6b.jpg";